import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import {
  RangeDateFilterDataGrid,
  StringFilterDataGrid,
} from 'app/common/ui/data-grid/filters';
import { appRoute } from 'app/railways/router/routes';

import { TEvent } from '../../core/events';

export const cols: TEntityGridColumn<TEvent>[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    sortable: true,
    comparator: () => 0,
  },
  {
    field: 'date',
    headerName: 'Дата',
    colId: 'date',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: string }) =>
      new Date(value).toLocaleString(),
    // @ts-expect-error ...
    filter: RangeDateFilterDataGrid({ filterName: 'date' }),
  },
  {
    field: 'actionType',
    headerName: 'Тип события',
    colId: 'actionType',
    sortable: true,
    comparator: () => 0,
    filter: StringFilterDataGrid({ filterName: 'actionType' }),
  },
  {
    field: 'description',
    headerName: 'Описание события',
    colId: 'description',
    sortable: true,
    comparator: () => 0,
    filter: StringFilterDataGrid({ filterName: 'description' }),
  },
  {
    field: 'userId',
    headerName: 'ID пользователя',
    colId: 'userId',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TEvent }) => {
      if (!data.userId) return null;
      const path = appRoute.USER.DETAILS.buildPath({
        id: data.userId,
      });
      return <Link to={path}>{data.userLogin}</Link>;
    },
  },
  {
    field: 'personId',
    headerName: 'ID пассажира',
    colId: 'personId',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TEvent }) => {
      if (!data.personId) return null;
      const path = appRoute.PERSON.DETAILS.buildPath({
        passengerId: Number(data.personId),
      });

      return <Link to={path}>{data.personId}</Link>;
    },
  },
  {
    field: 'ip',
    headerName: 'IP',
    colId: 'ip',
    sortable: true,
    comparator: () => 0,
  },
];
